import * as Checkbox from '@radix-ui/react-checkbox';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { CheckIcon } from '@radix-ui/react-icons';
import * as RadioGroup from '@radix-ui/react-radio-group';
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from 'react';
type DialogProps = {
  info?: any;
  setInfo?: Dispatch<SetStateAction<any>>;
  isModal?: boolean;
  validate?: boolean;
  actualStatus?: string;
  setValidate?: Dispatch<SetStateAction<boolean>>;
};
function StatusDetailsConcluido({
  info,
  setInfo,
  isModal,
  validate = true,
  setValidate,
  actualStatus
}: DialogProps) {
  const products = [
    'Odonto',
    'Saúde',
    'Saúde + Odonto',
    'Viagem',
    'Vida',
    'Previdência'
  ];

  const motivosSaude = [
    'Prestige',
    'Executivo',
    'Especial Mais',
    'Especial 100',
    'Clássico',
    'Exato',
    'Direto Nacional',
    'Direto Regional'
  ];

  const motivosVida = [
    'Acidentes pessoais',
    'Acidentes pessoais estagiários',
    'Vida simples',
    'Vida individual e Mulher',
    'Viagem',
    'Capital Global',
    'Você empresa',
    'Prestamista'
  ];

  const motivosOdonto = ['Individual', 'PME', 'PME MAIS', 'Empresarial'];

  const motivosSemSucesso = [
    {
      id: 'lgpd-bloqueado',
      nome: 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato'
    },
    {
      id: 'nao-responde',
      nome: 'Não responde | sem interação nos contatos realizados'
    },
    {
      id: 'dados-invalidos',
      nome: 'Dados inválidos'
    },
    {
      id: 'preco',
      nome: 'Preço'
    },
    {
      id: 'fora-rede',
      nome: 'Fora da rede credenciada | Fora da área de abrangência | Localização'
    },
    {
      id: 'concorrencia',
      nome: 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor'
    },
    {
      id: 'cnpj-inativo',
      nome: 'CNPJ inativo | Emissão de certidão negativa'
    },
    {
      id: 'mei-menos',
      nome: ' MEI menos de 6 meses'
    },
    {
      id: 'pj-1-vida',
      nome: ' PJ para 1 vida'
    },
    {
      id: 'ja-contratou',
      nome: 'Já contratou'
    },
    {
      id: 'converteu-saude',
      nome: 'Interesse em outros produtos | Converteu Saúde'
    },
    {
      id: 'converteu-odonto',
      nome: 'Interesse em outros produtos | Converteu Odonto'
    },
    {
      id: 'converteu-vida',
      nome: 'Interesse em outros produtos | Converteu Vida'
    },
    {
      id: 'converteu-viagem',
      nome: 'Interesse em outros produtos | Converteu Viagem'
    },
    {
      id: 'sem-interesse',
      nome: 'Não teve interesse'
    },
    {
      id: 'recusa-sula',
      nome: 'Recusa SulAmérica DPS'
    }
  ];

  const [selectedProducts, setSelectedProducts] = useState([
    ...(info?.query?.products || [])
  ]);
  const [selectedPlanSaude, setSelectedPlanSaude] = useState(
    info.plan_saude || ''
  );
  const [selectedPlanSaudeOdonto, setSelectedPlanSaudeOdonto] = useState(
    info.plan_saude_odonto || ''
  );
  const [selectedPlanOdonto, setSelectedPlanOdonto] = useState(
    info.plan_odonto || ''
  );
  const [selectedPlanViagem, setSelectedPlanViagem] = useState(
    info.plan_viagem || ''
  );
  const [selectedPlanVida, setSelectedPlanVida] = useState(
    info.plan_vida || ''
  );
  const [selectedPlanPrevidencia, setSelectedPrevidencia] = useState(
    info.plan_previdencia || ''
  );
  const [selectedMotivoSemSucesso, setSelectedMotivoSemSucesso] = useState({
    id: '',
    nome: ''
  });

  const [selectedAlreadySemSucesso, setSelectedAlreadySemSucesso] = useState({
    id: '',
    nome: ''
  });
  const [selectedType, setSelectedType] = useState(null);
  const [showPlans, setShowPlans] = useState([]);
  const [showProducts, setShowProducts] = useState([]);
  const changeProduct = (product = '') => {
    const findedProduct = selectedProducts.find((item) => item === product);

    if (!findedProduct) {
      setSelectedProducts([...selectedProducts, product]);
    } else {
      const array = [...selectedProducts];
      const remove = array.indexOf(product);
      array.splice(remove, 1);
      setSelectedProducts([...array]);
      changePlan(product, '');
    }
  };

  const searchMotivo = (id_motivo = '') => {
    const findedMotivo = motivosSemSucesso.find(
      (item) => item.id === id_motivo
    );
    if (findedMotivo) {
      setSelectedMotivoSemSucesso(findedMotivo);
    }
  };

  const changePlan = (product = '', plan = '') => {
    switch (product) {
      case 'Odonto':
        return setSelectedPlanOdonto(plan);
      case 'Saúde':
        return setSelectedPlanSaude(plan);
      case 'Saúde + Odonto':
        return setSelectedPlanSaudeOdonto(plan);
      case 'Viagem':
        return setSelectedPlanViagem(plan);
      case 'Vida':
        return setSelectedPlanVida(plan);
      case 'Previdência':
        return setSelectedPrevidencia(plan);
      default:
        return '';
    }
  };

  // const changeUniquePlan = (product = '', plan = '') => {
  //   switch (product) {
  //     case 'Odonto':
  //       {
  //         setSelectedPlanOdonto(plan);
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //     case 'Saúde':
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude(plan);
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //     case 'Saúde + Odonto':
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto(plan);
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //     case 'Viagem':
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem(plan);
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //     case 'Vida':
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida(plan);
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //     case 'Previdência':
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia(plan);
  //       }
  //       return;
  //     default:
  //       {
  //         setSelectedPlanOdonto('');
  //         setSelectedPlanSaude('');
  //         setSelectedPlanSaudeOdonto('');
  //         setSelectedPlanViagem('');
  //         setSelectedPlanVida('');
  //         setSelectedPrevidencia('');
  //       }
  //       return;
  //   }
  // };

  const showPlan = (product = '') => {
    switch (true) {
      case product === 'Odonto' && selectedPlanOdonto !== '':
        return selectedPlanOdonto;
      case product === 'Saúde' && selectedPlanSaude !== '':
        return selectedPlanSaude;
      case product === 'Vida' && selectedPlanVida !== '':
        return selectedPlanVida;
      default:
        return 'Selecione o plano ' + product?.toLocaleLowerCase();
    }
  };

  const changeMotivo = (product = '') => {
    switch (product) {
      case 'Odonto':
        return motivosOdonto;
      case 'Saúde':
        return motivosSaude;
      case 'Vida':
        return motivosVida;
      default:
        return undefined;
    }
  };

  const sendInfo = async () => {
    const formatProductAndPlans = {
      query: {
        plan_saude: selectedPlanSaude !== '' ? selectedPlanSaude : null,
        plan_odonto: selectedPlanOdonto !== '' ? selectedPlanOdonto : null,
        plan_vida: selectedPlanVida !== '' ? selectedPlanVida : null,
        products: selectedProducts.length > 0 ? selectedProducts : null,
        type: selectedType,
        sem_sucesso:
          selectedMotivoSemSucesso.id !== ''
            ? selectedMotivoSemSucesso.id
            : null
      }
    };

    for (const filter in formatProductAndPlans) {
      if (
        formatProductAndPlans[filter] === null ||
        formatProductAndPlans[filter] === ''
      ) {
        delete formatProductAndPlans[filter];
      }
    }

    setInfo({ ...formatProductAndPlans });
  };

  useEffect(() => {
    sendInfo();
  }, [
    selectedProducts,
    selectedPlanSaude,
    selectedPlanSaudeOdonto,
    selectedPlanOdonto,
    selectedPlanViagem,
    selectedPlanVida,
    selectedPlanPrevidencia,
    selectedMotivoSemSucesso
  ]);

  useEffect(() => {
    if (
      info?.details?.STATUS__c === 'Concluido' &&
      info?.details?.ABORDAGEM__c === true
    ) {
      setShowPlans(info?.details?.PLANOS__c || []);
      setShowProducts(info?.details?.PRODUTOS__c || []);
    }
    // if (actualStatus === 'Concluido') {
    //   const findMotivo = motivosSemSucesso.find(
    //     (motivo) => motivo.id === info?.details?.ABORDAGEM_N2__c
    //   );
    //   if (findMotivo) {
    //     setSelectedAlreadySemSucesso(findMotivo || null);
    //   }
    // }
  }, [info]);

  useEffect(() => {
    setSelectedType(info?.query?.type || null);
    const findMotivo = motivosSemSucesso.find(
      (motivo) => motivo.id === info?.query?.sem_sucesso
    );

    setSelectedProducts(info?.query.products || []);
    if (findMotivo) {
      setSelectedMotivoSemSucesso(findMotivo || null);
    }
  }, []);
  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <div>
          <span className="tw-text-sm tw-font-bold">
            Selecione uma das opções abaixo:{' '}
          </span>
          <a className="tw-text-red-500 tw-font-bold">*</a>
        </div>
        <div className="tw-flex tw-w-full tw-gap-2">
          <RadioGroup.Root
            className="tw-flex tw-w-full tw-gap-4"
            defaultValue=""
          >
            <div className="tw-flex tw-gap-2 tw-items-center tw-w-full ">
              <RadioGroup.Item
                value={'venda-realizada'}
                disabled={info?.details?.STATUS__c === 'Concluido'}
                className={
                  selectedType === 'venda-realizada'
                    ? `tw-rounded-full tw-w-[100%] tw-h-[2.5rem] tw-bg-[#FF5000] tw-text-white tw-font-bold  ${
                        validate === true
                          ? 'tw-border-[#001E64] '
                          : 'tw-border-[#AA2C23] '
                      }`
                    : `tw-border-[0.1rem] tw-rounded-full tw-border-solid  tw-text-[#001E64] tw-w-[100%] tw-h-[2.5rem] tw-font-bold ${
                        validate === true
                          ? 'tw-border-[#001E64] '
                          : 'tw-border-[#AA2C23] '
                      }`
                }
                id="c1"
                onClick={() => {
                  setSelectedType('venda-realizada');
                }}
              >
                <RadioGroup.Indicator></RadioGroup.Indicator>
                Venda realizada
              </RadioGroup.Item>
            </div>
            <div className="tw-flex tw-gap-2 tw-items-center tw-w-full">
              <RadioGroup.Item
                value={'venda-nao-realizada'}
                disabled={info?.details?.STATUS__c === 'Concluido'}
                className={
                  selectedType === 'venda-nao-realizada'
                    ? `tw-rounded-full tw-w-[100%] tw-h-[2.5rem] tw-bg-[#FF5000] tw-text-white tw-font-bold  ${
                        validate === true
                          ? 'tw-border-[#001E64] '
                          : 'tw-border-[#AA2C23] '
                      }`
                    : `tw-border-[0.1rem] tw-rounded-full tw-border-solid  tw-text-[#001E64] tw-w-[100%] tw-h-[2.5rem] tw-font-bold ${
                        validate === true
                          ? 'tw-border-[#001E64] '
                          : 'tw-border-[#AA2C23] '
                      }`
                }
                id="c1"
                onClick={() => {
                  setSelectedType('venda-nao-realizada');
                }}
              >
                <RadioGroup.Indicator></RadioGroup.Indicator>
                Venda não realizada
              </RadioGroup.Item>
            </div>
          </RadioGroup.Root>
        </div>
        <div></div>
        {selectedType === 'venda-realizada' && (
          <>
            <div className="tw-flex tw-flex-col tw-gap-2 ">
              <div>
                <span className="tw-font-bold ">Produtos </span>
                <a className="tw-text-red-500 tw-font-bold">*</a>
              </div>
              {showProducts.length <= 0 && (
                <div className="tw-flex tw-gap-6 tw-w-[100%]">
                  {isModal === true ? (
                    <div className="tw-flex tw-flex-col tw-w-[100%] tw-gap-2">
                      <div className="tw-flex tw-gap-2 tw-flex-col">
                        {products.map((product, index) => {
                          return (
                            <div
                              key={index}
                              className="tw-flex tw-items-center"
                            >
                              <input
                                type={'checkbox'}
                                className="tw-mr-2 tw-w-5 tw-h-5 tw-accent-[#001E64]"
                                onClick={() => {
                                  changeProduct(product);
                                }}
                                value={product}
                              />
                              <span>{product}</span>
                            </div>
                          );
                        })}
                      </div>
                      {/* </select> */}
                      {selectedProducts?.length > 0 && (
                        <>
                          {products.map((product, item) => {
                            if (selectedProducts.includes(product))
                              return (
                                changeMotivo(product) && (
                                  <div key={item}>
                                    <span className=" tw-flex tw-text-[#001E64] tw-items-center tw-justify-start tw-gap-1">
                                      <span className="tw-font-bold tw-text-black">
                                        Plano {product || ''}
                                      </span>
                                      <a className="tw-text-red-500 tw-font-bold">
                                        *
                                      </a>
                                    </span>
                                    <select
                                      className="tw-pl-1 tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full sm:tw-h-10 tw-min-h-[2.5rem] mb:tw-h-fit tw-w-[100%]"
                                      onChange={(e) => {
                                        changePlan(product, e.target.value);
                                      }}
                                    >
                                      <option value={''}>
                                        Selecione um plano
                                      </option>
                                      {changeMotivo(product).map(
                                        (item, index) => {
                                          return (
                                            <option
                                              key={index}
                                              className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                                            >
                                              {item}
                                            </option>
                                          );
                                        }
                                      )}
                                    </select>
                                  </div>
                                )
                              );
                          })}
                        </>
                      )}
                    </div>
                  ) : (
                    <DropdownMenu.Root>
                      <DropdownMenu.Trigger asChild className="tw-w-[100%]">
                        <button
                          className={`tw-pl-1 tw-border-[0.1rem] tw-rounded-full sm:tw-h-10 tw-min-h-[2.5rem] mb:tw-h-fit tw-w-[100%] ${
                            validate === true
                              ? ' tw-border-[#001E64]'
                              : ' tw-border-[#AA2C23]'
                          } `}
                          aria-label="Customise options"
                        >
                          <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2 tw-w-[100%]">
                            <span
                              className={
                                selectedProducts?.length <= 0
                                  ? 'tw-text-[#AAAAAA]'
                                  : 'tw-text-[#001E64]'
                              }
                            >
                              {selectedProducts?.length > 0
                                ? selectedProducts.toString()
                                : 'Selecione'}
                            </span>
                          </span>
                        </button>
                      </DropdownMenu.Trigger>

                      <DropdownMenu.Portal>
                        <DropdownMenu.Content
                          className="tw-w-[22rem] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                          sideOffset={5}
                        >
                          <form>
                            {products.map((product, index) => {
                              return (
                                <div className="tw-flex tw-gap-1" key={index}>
                                  <Checkbox.Root
                                    value={product}
                                    className="tw-border-[0.1rem] tw-rounded-sm tw-border-solid tw-border-black tw-w-[1.2rem] tw-h-[1.2rem]"
                                    id="c1"
                                    checked={selectedProducts.includes(product)}
                                    onClick={() => {
                                      changeProduct(product);
                                    }}
                                  >
                                    <Checkbox.Indicator>
                                      <CheckIcon />
                                    </Checkbox.Indicator>
                                  </Checkbox.Root>
                                  <label className="Label" htmlFor="c1">
                                    {product}
                                  </label>
                                </div>
                              );
                            })}
                          </form>
                        </DropdownMenu.Content>
                      </DropdownMenu.Portal>
                    </DropdownMenu.Root>
                  )}
                </div>
              )}
              {showProducts.length > 0 && (
                <>
                  <div className="tw-flex tw-gap-1">
                    {showProducts?.map((product, index) => {
                      return (
                        <span
                          key={index}
                          className=" tw-bg-[#001E64] tw-text-white tw-px-2 tw-rounded-lg"
                        >
                          <span>{product}</span>
                        </span>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
            {isModal !== true && (
              <div className="tw-flex tw-flex-col tw-gap-2 tw-my-2">
                {products.map((product, item) => {
                  if (
                    selectedProducts.includes(product) &&
                    showPlans.length <= 0
                  ) {
                    return (
                      changeMotivo(product) && (
                        <>
                          <div>
                            <span className="tw-font-bold">
                              Plano {product}{' '}
                            </span>
                            <a className="tw-text-red-500 tw-font-bold">*</a>
                          </div>
                          <DropdownMenu.Root key={item}>
                            <DropdownMenu.Trigger
                              asChild
                              className="tw-w-[100%]"
                            >
                              <button
                                className={`tw-pl-1 tw-border-[0.1rem] tw-border-solid  tw-text-[#001E64] tw-rounded-full sm:tw-h-10 tw-min-h-[2.5rem] mb:tw-h-fit tw-w-[100%] ${
                                  validate === true
                                    ? ' tw-border-[#001E64]'
                                    : ' tw-border-[#AA2C23]'
                                }`}
                                aria-label="Customise options"
                              >
                                <span className="tw-pl-1 tw-flex tw-text-[#001E64] tw-items-center tw-justify-start tw-gap-1">
                                  <span>{showPlan(product)}</span>
                                </span>
                              </button>
                            </DropdownMenu.Trigger>

                            <DropdownMenu.Portal>
                              <DropdownMenu.Content
                                className="tw-w-[25rem] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                                sideOffset={5}
                              >
                                {changeMotivo(product).map((item, index) => {
                                  return (
                                    <>
                                      <DropdownMenu.Item
                                        key={index}
                                        onClick={() => {
                                          changePlan(product, item);
                                        }}
                                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                                      >
                                        {item}
                                      </DropdownMenu.Item>
                                    </>
                                  );
                                })}
                              </DropdownMenu.Content>
                            </DropdownMenu.Portal>
                          </DropdownMenu.Root>
                        </>
                      )
                    );
                  }
                })}
                {showPlans.length > 0 && (
                  <>
                    <span className="tw-font-bold">Planos</span>
                    <div className="tw-flex tw-gap-1">
                      {showPlans?.map((plan, index) => {
                        return (
                          <span
                            key={index}
                            className=" tw-bg-[#001E64] tw-text-white tw-px-2 tw-rounded-lg"
                          >
                            <span>{plan}</span>
                          </span>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}
        {selectedType === 'venda-nao-realizada' && (
          <>
            <div className="tw-flex tw-flex-col tw-pb-6 tw-gap-2 tw-mb-2">
              <div>
                <span className="tw-font-bold">Motivo </span>
                <a className="tw-text-red-500 tw-font-bold">*</a>
              </div>
              {isModal === true ? (
                <div className="tw-flex tw-flex-col tw-w-[100%] tw-gap-2">
                  <select
                    className="tw-pl-1 tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full tw-h-10 "
                    id="c1"
                    placeholder="Selecione"
                    onChange={(e) => {
                      searchMotivo(e.target.value);
                    }}
                  >
                    <option value={''} selected>
                      Selecione o motivo
                    </option>
                    {motivosSemSucesso.map((motivo, index) => {
                      return (
                        <option className="Label" key={index} value={motivo.id}>
                          {motivo.nome}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild className="tw-w-[100%]">
                    <button
                      className="tw-pl-1 tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-full tw-h-10 tw-w-[100%]"
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2 tw-w-[100%]">
                        <span>
                          {selectedMotivoSemSucesso.id !== ''
                            ? selectedMotivoSemSucesso.nome.length >= 20
                              ? selectedMotivoSemSucesso.nome?.substring(
                                  0,
                                  55
                                ) + '...'
                              : selectedMotivoSemSucesso.nome
                            : 'Selecione o motivo '}
                        </span>
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="tw-w-[100%] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedMotivoSemSucesso({
                            id: '',
                            nome: ''
                          });
                        }}
                        className="hover:tw-bg-slate-200 tw-font-bold tw-w-[100%] tw-cursor-pointer"
                      >
                        Selecione o motivo:
                      </DropdownMenu.Item>
                      {motivosSemSucesso.map((motivo, index) => {
                        return (
                          <DropdownMenu.Item
                            key={index}
                            onClick={() => {
                              setSelectedMotivoSemSucesso({
                                id: motivo.id,
                                nome: motivo.nome
                              });
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                          >
                            {motivo.nome}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              )}
            </div>
          </>
        )}
        {validate === false && (
          <div className="tw-text-[#AA2C23]">
            Por favor, preencha os campos obrigatórios acima.
          </div>
        )}
      </div>
    </>
  );
}

export default StatusDetailsConcluido;
